import { createSlice } from "@reduxjs/toolkit";

export const quoteListSlice = createSlice({
  name: "quoteList",
  initialState: {
    byId: {},
    allIds: [],
    totalRecords: 0,
    selectedQuote: null,
    filteredRecords: 0,
    isSingleQuoteLoading: false,
    isSingleQuoteNotFound: false,
    isLoading: false,
  },
  reducers: {
    setAllQuotesLoadingState: (state, action) => {
      state.isLoading = true;
    },
    setSinglQuoteLoadingState: (state, action) => {
      state.isSingleQuoteLoading = true;
    },
    loadAllQuotes: (state, action) => {
      const listObj = {};
      action.payload.quotes.forEach((value) => {
        listObj[value.id] = value;
      });
      state.byId = listObj;
      state.allIds = action.payload.quotes.map((value) => value.id);
      state.totalRecords = action.payload.totalRecords;
      state.filteredRecords = action.payload.filteredRecords;
      state.isLoading = false;
    },
    loadSingleQuote: (state, action) => {
      state.selectedQuote =
        action.payload && action.payload.length === 1
          ? action.payload[0]
          : null;
      state.isSingleQuoteLoading = false;
    },
    setSingleQuoteNotFound: (state, action) => {
      state.isSingleQuoteNotFound = action.payload;
    },
  },
});

export const {
  setAllQuotesLoadingState,
  setSingleEQuoteLoadingState,
  loadAllQuotes,
  loadSingleQuote,
  setSingleQuoteNotFound,
} = quoteListSlice.actions;

export default quoteListSlice.reducer;
